import type { SessionCapabilities } from "../api/sessionContext";

export const OPERATIONAL_CAPABILITIES: readonly (keyof SessionCapabilities)[] = [
  "manage_access",
  "read_members",
  "create_members",
  "write_members",
  "write_departments",
  "reset_password",
  "read_audit",
  "request_mfa_recovery",
  "approve_mfa_recovery",
  "read_payments",
  "record_payment",
  "adjust_payment",
] as const;

export function isOperationalUser(capabilities: SessionCapabilities | null | undefined): boolean {
  if (!capabilities) return false;
  return OPERATIONAL_CAPABILITIES.some((key) => Boolean(capabilities[key]));
}

const SECRETARY_CAPABILITIES: readonly (keyof SessionCapabilities)[] = [
  "write_members",
  "write_departments",
  "reset_password",
  "request_mfa_recovery",
  "record_payment",
  "adjust_payment",
] as const;

interface RoleRule {
  readonly label: string;
  readonly match: (caps: SessionCapabilities) => boolean;
}

const ROLE_RULES: readonly RoleRule[] = [
  { label: "Administrador técnico", match: (caps) => Boolean(caps.manage_access) },
  { label: "Secretaria/DAF", match: (caps) => SECRETARY_CAPABILITIES.some((key) => Boolean(caps[key])) },
  { label: "Gestão / Diretoria", match: (caps) => Boolean(caps.approve_mfa_recovery) },
  { label: "Consulta institucional", match: (caps) => Boolean(caps.read_members) },
  { label: "Acesso institucional", match: (caps) => Boolean(caps.read_payments) },
];

export function roleLabel(capabilities: SessionCapabilities | null | undefined, hasMember = false): string {
  if (capabilities) {
    const matched = ROLE_RULES.find((rule) => rule.match(capabilities));
    if (matched) return matched.label;
  }
  return hasMember ? "Associado" : "Acesso institucional";
}
